module.exports = __webpack_public_path__ + "img/img01.aa34ee55.png";